/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DealsSearchCriteriaForm
 */
export interface DealsSearchCriteriaForm {
    /**
     * 
     * @type {Array<string>}
     * @memberof DealsSearchCriteriaForm
     */
    'dealStatusList'?: Array<DealsSearchCriteriaFormDealStatusListEnum>;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'userAccountGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'dealKeyword'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DealsSearchCriteriaForm
     */
    'dealIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'amountLowerLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'amountUpperLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'qualifiedEvidence'?: DealsSearchCriteriaFormQualifiedEvidenceEnum;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'accountItemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'taxCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'itemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'sectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'tagId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'partnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DealsSearchCriteriaForm
     */
    'canSync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DealsSearchCriteriaForm
     */
    'isInvalidTaxCode'?: boolean | null;
}

export const DealsSearchCriteriaFormDealStatusListEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type DealsSearchCriteriaFormDealStatusListEnum = typeof DealsSearchCriteriaFormDealStatusListEnum[keyof typeof DealsSearchCriteriaFormDealStatusListEnum];
export const DealsSearchCriteriaFormQualifiedEvidenceEnum = {
    allNotQualified: 'ALL_NOT_QUALIFIED',
    containQualified: 'CONTAIN_QUALIFIED'
} as const;

export type DealsSearchCriteriaFormQualifiedEvidenceEnum = typeof DealsSearchCriteriaFormQualifiedEvidenceEnum[keyof typeof DealsSearchCriteriaFormQualifiedEvidenceEnum];


